import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import BillingExceptionsPanel from "./AllocationWizard/BillingExceptionsPanel";

const ExceptionsDrawer = ({ open, onClose, row }) => {
  const theme = useTheme();
  const t = theme.custom;

  if (!open) return null;

  const requestId = row?.requestId ?? row?.id ?? row?.allocationId;

  return (
    <>
      {/* Backdrop */}
      <Box
        onClick={onClose}
        sx={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.45)",
          zIndex: 1200,
        }}
      />

      {/* Drawer */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "480px",
          height: "100vh",
          background: t.surface,
          borderLeft: `1px solid ${t.border2}`,
          zIndex: 1201,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "18px 24px",
            borderBottom: `1px solid ${t.border2}`,
            flexShrink: 0,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: "'Inter', sans-serif",
                fontSize: "15px",
                fontWeight: 700,
                color: t.text,
              }}
            >
              Billing Exceptions
            </Typography>
            {row && (
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px", mt: "2px" }}>
                <Typography sx={{ fontFamily: "'DM Mono', monospace", fontSize: "10px", color: t.accent }}>
                  {row.positionCode ?? row.position?.positionCode ?? ""}
                </Typography>
                <Typography sx={{ fontFamily: "'DM Mono', monospace", fontSize: "10px", color: t.text3 }}>
                  {row.associateName ?? ""}
                </Typography>
              </Box>
            )}
          </Box>
          <Box
            onClick={onClose}
            sx={{
              cursor: "pointer",
              color: t.text3,
              fontSize: "18px",
              lineHeight: 1,
              padding: "4px",
              "&:hover": { color: t.text },
            }}
          >
            ✕
          </Box>
        </Box>

        {/* Body */}
        <Box sx={{ flex: 1, overflowY: "auto", padding: "20px 24px" }}>
          <BillingExceptionsPanel requestId={requestId} readOnly={false} positionType={row?.positionType} />
        </Box>

        {/* Footer */}
        <Box
          sx={{
            padding: "16px 24px",
            borderTop: `1px solid ${t.border2}`,
            display: "flex",
            justifyContent: "flex-end",
            flexShrink: 0,
          }}
        >
          <Box
            onClick={onClose}
            sx={{
              padding: "8px 20px",
              borderRadius: "3px",
              cursor: "pointer",
              border: `1px solid ${t.border2}`,
              fontFamily: "'DM Mono', monospace",
              fontSize: "11px",
              color: t.text2,
              transition: "all 0.15s",
              "&:hover": { borderColor: t.border3, color: t.text },
            }}
          >
            Close
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ExceptionsDrawer;
